import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/store._index'
import Dynamic from '../components/page/DynamicResolvePage.vue'
import Resolver from '../components/page/SubPageResolver.vue'
import ResolverPreview from '../components/page/SubPageResolverPreview.vue'
import Search from '../components/page/Search.vue'
import AuthWelcomeBook from '../components/welcomeBook/AuthPage.vue'
import Welcomebook from '../components/welcomeBook/Welcomebook.vue'
import Preview from '../components/page/Preview.vue'
import partnerInfo from '../components/contentComponents/ContentType.PartnerInfo.vue'
import Presentation from '../components/presentation/presentation.vue'
// import { component } from 'vue/types/umd'
// const Error404 = () => import(/* webpackChunkName: "page" */ '../components/app/Error404.vue')

Vue.use(VueRouter)

const routes = [
  {
    name: 'home',
    path: '/',
    redirect: '/page/home'
  },
  {
    path: '/page/:urlKey',
    name: 'page',
    component: Dynamic,
    children: [
      {
        path: ':subUrlKey',
        name: 'subDynamic',
        component: Resolver,
        props: true
      }
    ]
  },
  {
    path: '/partnerInfo/:id',
    name: 'partnerInfo',
    component: partnerInfo,
    props: true
  },
  {
    path: '/preview',
    name: 'preview',
    component: Preview,
    children: [
      {
        path: ':subUrlKey',
        name: 'subDynamicPreview',
        component: ResolverPreview,
        props: true
      }
    ]
  },
  {
    path: '/Welcomebook',
    redirect: '/page/welcomebook',
    name: 'welcomebook',
    meta: { requireAuthorization: true },
    component: Welcomebook
  },
  {
    path: '/search',
    name: 'search',
    component: Search
  },
  {
    path: '*',
    name: 'error404',
    redirect: '/page/home'
    // component: Error404
  },
  {
    path: '/Authorize',
    name: 'authrise',
    component: AuthWelcomeBook
  },
  {
    path: '/Presentation',
    name: 'Presentation',
    component: Presentation
  }
]

const router = new VueRouter({
  // mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const isLogined = store.state.WelcomeBookauthModule.authenticated
  if (!isLogined && to.meta && to.meta.requireAuthorization === true) {
    next({ path: '/Authorize' })
    // TODO Fix hardcoded router pathes to welcomebook
  } else if (!isLogined && (to.fullPath === '/page/welcomebook' || to.redirectedFrom === '/welcomebook')) {
    next({ path: '/Authorize' })
  }
  next()
})

export default router
